import { readLocalStorage, useLocalStorage } from 'shared/hooks';
import { getUserId } from 'shared/utils/userId';
export var useDismissNotification = function (memberId, status) {
    var key = "sud_dismiss_notification_on_".concat(getUserId(), "_").concat(memberId);
    var getNotificationDismissed = readLocalStorage(key, null);
    var _a = useLocalStorage(key, null), setNotificationDismissed = _a[1];
    var dismissStatusValue = getNotificationDismissed();
    var isNotificationDismissed = false;
    if (dismissStatusValue === status) {
        isNotificationDismissed = true;
    }
    else if (dismissStatusValue !== null) {
        // If the status value is different, we need to remove the old value
        setNotificationDismissed(null);
    }
    return {
        isNotificationDismissed: isNotificationDismissed,
        dismissNotification: function () { return setNotificationDismissed(status); },
    };
};
